/**
 * Module-level cache of the currently-active project id.
 *
 * This is a bridge between React (which knows the active project from the URL
 * via `PropertyProvider`) and the plain-TS `requests.ts` wrapper, which is not
 * a React component and therefore cannot call hooks. The provider calls
 * `setActiveProjectId` when the URL changes; the request wrapper reads it via
 * `getActiveProjectId` and auto-appends `?project_id=<id>` to every outgoing
 * request that doesn't already specify one.
 */

let activeProjectId: string | null = null;

export const setActiveProjectId = (id: string | null): void => {
  activeProjectId = id;
};

export const getActiveProjectId = (): string | null => activeProjectId;
